export const guardianListData = [
  {
    key: "1",
    id: "G153735",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "William",
    Addedon: "Added on 25 Mar 2024",
    Child: "Janet",
    class: "III, A",
    phone: "+1 82392 37359",
    email: "william@example.com",
  },
  {
    key: "2",
    id: "G153734",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Stacey",
    Addedon: "Added on 18 Mar 2024",
    Child: "Joann",
    class: "IV, B",
    phone: "+1 28249 13139",
    email: "stacey@example.com",
  },
  {
    key: "3",
    id: "G153733",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "George",
    Addedon: "Added on 14 Mar 2024",
    Child: "Kathleen",
    class: "III, A",
    phone: "+1 74284 34849",
    email: "george@example.com",
  },
  {
    key: "4",
    id: "G153732",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Sarah",
    Addedon: "Added on 27 Feb 2024",
    Child: "Gifford",
    class: "I, B",
    phone: "+1 49230 23294",
    email: "sarah@example.com",
  },
  {
    key: "5",
    id: "G153731",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Gary",
    Addedon: "Added on 11 Feb 2024",
    Child: "Lisa",
    class: "II, B",
    phone: "+1 82239 42492",
    email: "gary@example.com",
  },
  {
    key: "6",
    id: "G153730",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Linda",
    Addedon: "Added on 24 Jan 2024",
    Child: "Ralph",
    class: "III, B",
    phone: "+1 90139 45835",
    email: "linda@example.com",
  },
  {
    key: "7",
    id: "G153729",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Jeffrey",
    Addedon: "Added on 19 Jan 2024",
    Child: "Julie",
    class: "V, A",
    phone: "+1 23230 37402",
    email: "jeffrey@example.com",
  },
  {
    key: "8",
    id: "G153728",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Galina",
    Addedon: "Added on 08 Jan 2024",
    Child: "Janet",
    class: "III, A",
    phone: "+1 91304 34834",
    email: "galina@example.com",
  },
  {
    key: "9",
    id: "G153727",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Paul",
    Addedon: "Added on 22 Dec 2023",
    Child: "Susan",
    class: "VIII, B",
    phone: "+1 84394 28204",
    email: "paul@example.com",
  },
  {
    key: "10",
    id: "G153726",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Tracy",
    Addedon: "Added on 15 Dec 2024",
    Child: "Richard",
    class: "VII, B",
    phone: "+1 93402 39342",
    email: "tracy@example.com",
  },
  {
    key: "11",
    id: "G153725",
    GuardianImage: "https://imageplaceholder.net/300",
    ChildImage: "https://imageplaceholder.net/300",
    name: "Ramos",
    Addedon: "Added on 10 Dec 2023",
    Child: "Veronica",
    class: "IX, A",
    phone: "+1 57571 74821",
    email: "ram@example.com",
  },
];
